module.exports = __webpack_public_path__ + "static/media/ZRX.68dfa868.svg";